import { createContext as x, useContext as P, useMemo as w, useReducer as le, useRef as H, useEffect as de, useCallback as C, useState as he } from "react";
import { jsx as v, jsxs as fe } from "react/jsx-runtime";
import { QueryClient as pe, QueryClientProvider as ge, useQueryClient as N, useQuery as Se, useInfiniteQuery as ye } from "@tanstack/react-query";
import { useRequester as me } from "@made-people/react-use-requester";
import { useInjectStructuredDataProducts as we } from "@made-people/grease-structured-data";
const b = x(
  void 0
), G = x(void 0);
function ve() {
  const e = P(G);
  if (e === void 0)
    throw new Error(
      "useFacetSorting must be used within a SearchResultProvider"
    );
  return e;
}
const W = x([]), Pe = () => {
  const e = P(W);
  if (e === void 0)
    throw new Error("useExcludedFacets must be used within a SearchProvider");
  return e;
}, B = new pe({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1e3,
      // 5 minutes
      gcTime: 30 * 60 * 1e3,
      // 30 minutes
      retry: 2,
      retryDelay: (e) => Math.min(1e3 * 2 ** e, 3e4)
    },
    mutations: {
      retry: 1
    }
  }
}), Be = () => {
  B.clear();
}, Z = ({
  children: e,
  queryClient: t = B
}) => /* @__PURE__ */ v(ge, { client: t, children: e });
Z.displayName = "SearchResultReactQueryProvider";
const z = x(
  null
), xe = () => P(z), Re = (e) => {
  var s, o;
  const t = {
    globalSearchSettings: e.globalSearchSettings,
    searchData: e.searchData,
    structuredDataMapper: e.structuredDataMapper
  }, r = {
    facets: ((s = e.facetSorting) == null ? void 0 : s.facets) ?? "auto",
    values: ((o = e.facetSorting) == null ? void 0 : o.values) ?? "auto"
  }, n = e.excludedFacets ?? [];
  return /* @__PURE__ */ v(b.Provider, { value: t, children: /* @__PURE__ */ v(W.Provider, { value: n, children: /* @__PURE__ */ v(z.Provider, { value: e.facetGrouping ?? null, children: /* @__PURE__ */ v(G.Provider, { value: r, children: /* @__PURE__ */ v(Z, { children: e.children }) }) }) }) });
};
Re.displayName = "SearchProvider";
const Ze = {
  search: "search"
}, J = x(void 0), ze = (e) => {
  const t = {
    autoCompleteClient: e.autoCompleteClient
  };
  return /* @__PURE__ */ v(J.Provider, { value: t, children: e.children });
}, Ce = () => {
  const e = P(J);
  if (!e)
    throw new Error(
      "useAutoCompleteClient must be used within a AutoCompleteProvider"
    );
  return e.autoCompleteClient;
}, Je = () => {
  const e = Ce();
  return me(async (r) => {
    try {
      return await e.search(r);
    } catch (n) {
      throw n;
    }
  });
};
function be(e, t) {
  switch (t.type) {
    case "SET_RESULT":
      return {
        ...e,
        result: t.payload
      };
    case "LOAD_PAGE":
      return e.result ? {
        ...e,
        result: {
          ...e.result,
          items: [...e.result.items, ...t.payload.items],
          meta: {
            ...e.result.meta,
            currentPage: t.payload.page
          }
        }
      } : e;
    default:
      return e;
  }
}
const X = x(void 0), Y = x(void 0);
function F() {
  const e = P(X);
  if (e === void 0)
    throw new Error(
      "useSearchResultState must be used within a SearchResultProvider"
    );
  return e;
}
function Fe() {
  var t;
  return (t = F().result) == null ? void 0 : t.items;
}
const q = () => {
  const e = P(b);
  if (!e)
    throw new Error(
      "useStructuredDataProductsMapper must be used within a SearchProvider"
    );
  return e.structuredDataMapper;
}, Ee = (e) => {
  const t = Fe(), r = q(), n = w(() => {
    if (!r)
      return;
    const s = [];
    return t == null || t.forEach((o) => {
      o.type === "product" && s.push(r(o.product));
    }), s;
  }, [t]);
  return we(n), null;
}, ee = x(void 0), te = (e) => {
  const [t, r] = le(be, {
    result: e.result
  }), n = H(!0), s = q();
  return de(() => {
    n.current ? n.current = !1 : r({ type: "SET_RESULT", payload: e.result });
  }, [e.result]), /* @__PURE__ */ v(X.Provider, { value: t, children: /* @__PURE__ */ fe(Y.Provider, { value: r, children: [
    s && /* @__PURE__ */ v(Ee, {}),
    e.children
  ] }) });
};
te.displayName = "SearchResultProvider";
const ke = (e, t, r) => {
  const n = t && Object.keys(t).length > 0, s = r && r.length > 0;
  return n && s ? ["search", e, "facets", t, "sort", r] : n ? ["search", e, "facets", t] : s ? ["search", e, "sort", r] : ["search", e];
}, E = (e, t, r) => ke(
  e,
  Object.keys(t).length > 0 ? t : void 0,
  r.length > 0 ? r : void 0
), k = (e, t) => {
  const r = e.values.map((s) => s.id === t ? {
    ...s,
    selected: !s.selected
  } : s), n = r.filter((s) => s.selected).length;
  return {
    ...e,
    values: r,
    selectedCount: n
  };
}, re = (e, t) => e.map((r) => {
  if (r.id === t) {
    const n = !r.selected;
    if (r.children && r.children.length > 0) {
      const s = (o) => o.map((a) => ({
        ...a,
        selected: n,
        children: a.children ? s(a.children) : a.children
      }));
      return {
        ...r,
        selected: n,
        children: s(r.children)
      };
    } else
      return {
        ...r,
        selected: n
      };
  }
  return r.children ? {
    ...r,
    children: re(r.children, t)
  } : r;
}), ne = (e) => e.map((t) => {
  if (t.children && t.children.length > 0) {
    const r = ne(t.children), n = r.every(
      (s) => s.selected
    );
    return {
      ...t,
      selected: n,
      children: r
    };
  }
  return t;
}), Q = (e, t) => {
  const r = re(e.values, t), n = ne(r), s = (a) => a.reduce((u, c) => {
    let d = c.selected ? 1 : 0;
    return c.children && (d += s(c.children)), u + d;
  }, 0), o = s(n);
  return {
    ...e,
    values: n,
    selectedCount: o
  };
}, I = (e) => {
  const t = [];
  for (const r of e)
    r.selected && t.push(r), r.children && t.push(
      ...I(r.children)
    );
  return t;
}, Qe = (e) => {
  const t = [], r = (n) => {
    for (const s of n) {
      if (s.selected) {
        t.push(s);
        continue;
      }
      s.children && s.children.length > 0 && r(s.children);
    }
  };
  return r(e), t;
}, Ie = async (e, t, r, n) => {
  let s = e;
  for (const [o, a] of Object.entries(t)) {
    const u = s.facets.find((d) => d.id === o);
    if (!u)
      continue;
    let c = [...s.facets];
    for (const d of a)
      u.type === "checkbox" ? c = c.map((l) => l.id === o && l.type === "checkbox" ? k(l, d) : l) : u.type === "checkbox-hierarchical" && (c = c.map((l) => l.id === o && l.type === "checkbox-hierarchical" ? Q(l, d) : l));
    s = await n.setFacets(c, s);
  }
  if (r.length > 0) {
    const o = s.sort.map((a) => ({
      ...a,
      selected: r.includes(a.id)
    }));
    s = await n.setSortOrder(
      o,
      s
    );
  }
  return s;
}, D = (e) => {
  if (!e)
    return { facets: {}, sort: [] };
  const t = e.facets.reduce(
    (n, s) => {
      const o = U(s);
      return o.length > 0 && (n[s.id] = o), n;
    },
    {}
  ), r = se(e.sort || []);
  return { facets: t, sort: r };
}, se = (e) => e.filter((t) => t.selected).map((t) => t.id).sort(), L = (e) => {
  const t = [];
  return Object.keys(e.facets).length > 0 && t.push("facets", e.facets), e.sort.length > 0 && t.push("sort", e.sort), t;
}, U = (e) => {
  var r, n;
  let t = [];
  return e.type === "checkbox-hierarchical" ? t = ce(
    e.values
  ) : e.type === "group" ? t = e.children.flatMap(
    (s) => U(s)
  ) : t = ((n = (r = e.values) == null ? void 0 : r.filter((s) => s.selected)) == null ? void 0 : n.map((s) => s.id)) || [], t.sort();
}, ce = (e) => {
  const t = [];
  for (const r of e)
    r.selected && t.push(r.id), r.children && t.push(...ce(r.children));
  return t;
}, De = (e) => {
  const t = {};
  return e.forEach((r, n) => {
    if (n.startsWith("facet_")) {
      const s = n.replace("facet_", "");
      t[s] = r.split(",");
    }
  }), t;
}, Le = (e) => {
  const t = e.get("sort");
  return t ? t.split(",") : [];
}, j = (e, t, r, n) => {
  const s = new URLSearchParams(r);
  for (const [a] of r.entries())
    a.startsWith("facet_") && s.delete(a);
  s.delete("sort"), e.forEach((a) => {
    let u = [];
    a.type === "checkbox" ? u = a.values.filter((c) => c.selected).map((c) => c.id) : a.type === "checkbox-hierarchical" ? u = I(a.values).map((d) => d.id) : a.type === "group" && a.children.forEach((c) => {
      let d = [];
      c.type === "checkbox" ? d = c.values.filter((l) => l.selected).map((l) => l.id) : c.type === "checkbox-hierarchical" && (d = I(c.values).map((i) => i.id)), d.length > 0 && s.set(
        `facet_${c.id}`,
        d.join(",")
      );
    }), a.type !== "group" && u.length > 0 && s.set(`facet_${a.id}`, u.join(","));
  });
  const o = t.filter((a) => a.selected).map((a) => a.id);
  o.length > 0 && s.set("sort", o.join(",")), window.history.replaceState(
    null,
    "",
    `${n}?${s.toString()}`
  );
}, Xe = (e, t) => {
  const r = new URLSearchParams(e);
  for (const [n] of e.entries())
    n.startsWith("facet_") && r.delete(n);
  r.delete("sort"), window.history.replaceState(
    null,
    "",
    `${t}?${r.toString()}`
  );
}, Ve = (e, t, r, n, s) => async (o, a) => {
  var c, d;
  const u = ((c = e.data) == null ? void 0 : c.pages.length) || 0;
  if (o === u + 1) {
    const l = await e.fetchNextPage(), i = (d = l.data) == null ? void 0 : d.pages[l.data.pages.length - 1], g = s();
    if (l.data && g) {
      const h = l.data.pages.flatMap(
        (S) => Array.isArray(S) ? S : S && typeof S == "object" && "items" in S ? S.items : []
      ), y = {
        ...g,
        items: h,
        meta: {
          ...g.meta,
          currentPage: l.data.pages.length
        }
      };
      r.setQueryData(n, y);
    }
    return i && typeof i == "object" && "items" in i ? i.items : [];
  }
  return await t.loadPage(o, a);
}, Te = (e, t, r, n, s, o, a, u) => ({
  ...e,
  // Apply facet filters while maintaining cache and URL state
  setFacets: async (c, d) => {
    const l = await e.setFacets(
      c,
      d
    ), i = (n == null ? void 0 : n.sort) || [], { urlFacetsData: g, urlSortData: h } = u(
      c,
      i
    ), y = E(
      r,
      g,
      h
    );
    return t.setQueryData(y, l), a(l), j(
      c,
      i,
      s,
      o
    ), l;
  },
  // Apply sort order changes while maintaining cache and URL state
  setSortOrder: async (c, d) => {
    const l = await e.setSortOrder(
      c,
      d
    ), i = (n == null ? void 0 : n.facets) || [], { urlFacetsData: g, urlSortData: h } = u(
      i,
      c
    ), y = E(
      r,
      g,
      h
    );
    return t.setQueryData(y, l), a(l), j(
      i,
      c,
      s,
      o
    ), l;
  },
  reset: async () => {
    const c = E(r, {}, []), d = t.getQueryData(c);
    if (d) {
      await t.cancelQueries({
        queryKey: ["search", r, "infinite"],
        exact: !1
      }), t.removeQueries({
        queryKey: ["search", r, "infinite"],
        exact: !1
      });
      const h = new URLSearchParams(s);
      for (const [f] of s.entries())
        f.startsWith("facet_") && h.delete(f);
      h.delete("sort");
      const y = h.toString(), S = y ? `${o}?${y}` : o;
      return window.history.replaceState(null, "", S), await t.invalidateQueries({
        queryKey: ["search", r],
        exact: !1
      }), a(d), window.scrollTo({ top: 0 }), d;
    }
    const l = new URLSearchParams(s);
    for (const [h] of s.entries())
      h.startsWith("facet_") && l.delete(h);
    l.delete("sort");
    const i = l.toString(), g = i ? `${o}?${i}` : o;
    window.location.href = g;
  }
}), $ = async (e, t) => {
  await e.cancelQueries({
    queryKey: ["search", t, "infinite"],
    exact: !1
  }), e.removeQueries({
    queryKey: ["search", t, "infinite"],
    exact: !1
  }), window.scrollTo({ top: 0 });
}, Ue = ({
  queryParams: e,
  searchMethods: t,
  urlFacets: r = {},
  urlSort: n = [],
  mode: s = "CLIENT",
  initialSearchResult: o
}) => {
  var S;
  const a = N(), u = w(
    () => E(e, r, n),
    [e, r, n]
  ), c = Se({
    queryKey: u,
    queryFn: async () => {
      if (s === "SSR" && o)
        return o;
      if (Object.keys(r).length > 0 || n.length > 0) {
        const f = await t.fetchSearchResult();
        return await Ie(
          f,
          r,
          n,
          t
        );
      }
      return t.fetchSearchResult();
    },
    initialData: s === "SSR" && o ? o : void 0,
    staleTime: s === "SSR" ? 1 / 0 : void 0,
    refetchOnWindowFocus: !1
  }), d = w(
    () => D(c.data),
    [c.data]
  ), l = w(
    () => [
      "search",
      e,
      "infinite",
      ...L(d)
    ],
    [e, d]
  ), i = ye({
    queryKey: l,
    queryFn: async ({ pageParam: f = 1 }) => {
      var m, R;
      if (f === 1) {
        if (!c.data)
          throw new Error("Cannot start infinite query without search data");
        return c.data;
      }
      const p = await t.loadPage(f, c.data);
      return {
        items: p,
        meta: {
          currentPage: f,
          totalPages: ((m = c.data) == null ? void 0 : m.meta.totalPages) || 0,
          totalItems: ((R = c.data) == null ? void 0 : R.meta.totalItems) || 0,
          itemsPerPage: p.length
        }
      };
    },
    getNextPageParam: (f, p) => {
      var R;
      const m = p.length;
      return m < (((R = f.meta) == null ? void 0 : R.totalPages) || 0) ? m + 1 : void 0;
    },
    initialPageParam: 1,
    enabled: !!c.data,
    refetchOnWindowFocus: !1
  }), g = {
    // Load additional pages using infinite query pattern
    loadPage: C(
      Ve(
        i,
        t,
        a,
        u,
        () => c.data
      ),
      [
        i,
        t,
        a,
        u,
        c.data
      ]
    ),
    // Apply facet filters and update base cache
    setFacets: C(
      async (f, p) => {
        const m = await t.setFacets(
          f,
          p
        );
        return await $(a, e), a.setQueryData(u, m), m;
      },
      [t, a, u, e, l]
    ),
    // Apply sort order changes
    setSortOrder: C(
      async (f, p) => {
        const m = await t.setSortOrder(
          f,
          p
        );
        return await $(a, e), a.setQueryData(u, m), m;
      },
      [t, a, e, l]
    ),
    // Reset search to initial state
    reset: C(async () => c.data || await c.refetch().then((f) => f.data), [c])
  }, h = w(
    () => {
      var f;
      return ((f = i.data) == null ? void 0 : f.pages.flatMap((p) => Array.isArray(p) ? p : p && typeof p == "object" && "items" in p ? p.items : [])) || [];
    },
    [i.data]
  );
  return {
    results: w(
      () => {
        var f;
        return c.data ? {
          ...c.data,
          items: h.length > 0 ? h : c.data.items,
          meta: {
            ...c.data.meta,
            currentPage: ((f = i.data) == null ? void 0 : f.pages.length) || 1
          }
        } : void 0;
      },
      [c.data, h, (S = i.data) == null ? void 0 : S.pages.length]
    ),
    queryMethods: g
  };
}, Ae = (e, t, r, n) => {
  const s = D(r), o = [
    "search",
    t,
    "infinite",
    ...L(s)
  ], a = D(n), u = [
    "search",
    t,
    "infinite",
    ...L(a)
  ], c = e.getQueryData(o);
  if (c != null && c.pages && c.pages.length > 1) {
    const d = {
      ...c,
      pages: [n, ...c.pages.slice(1)],
      pageParams: c.pageParams
    };
    e.setQueryData(u, d);
  }
}, Ke = ({
  queryParams: e,
  searchMethods: t,
  mode: r = "CLIENT",
  initialSearchResult: n,
  children: s
}) => {
  const o = P(b), a = N();
  if (!o)
    throw new Error(
      "CachedSearchResultsProvider must be used within a SearchProvider"
    );
  const { searchData: u } = o, c = u.urlSearchParams, d = w(
    () => De(c),
    [c.toString()]
  ), l = w(
    () => Le(c),
    [c.toString()]
  ), { results: i, queryMethods: g } = Ue({
    queryParams: e,
    searchMethods: t,
    urlFacets: d,
    urlSort: l,
    mode: r,
    initialSearchResult: n
  }), h = (f, p) => {
    const m = f.reduce(
      (O, M) => {
        const _ = U(M);
        return _.length > 0 && (O[M.id] = _), O;
      },
      {}
    ), R = se(p);
    return { urlFacetsData: m, urlSortData: R };
  }, y = C(
    (f) => {
      Ae(a, e, i, f);
    },
    [a, e, i]
  ), S = Te(
    g,
    a,
    e,
    i,
    c,
    u.pathname,
    y,
    h
  );
  return /* @__PURE__ */ v(ee.Provider, { value: S, children: /* @__PURE__ */ v(te, { result: i, children: s }) });
};
Ke.displayName = "CachedSearchResultsProvider";
function A() {
  const e = P(Y);
  if (e === void 0)
    throw new Error(
      "useSearchResultDispatch must be used within a SearchResultProvider"
    );
  return e;
}
const K = () => {
  const e = P(ee);
  if (e === void 0)
    throw new Error(
      "useSearchResultQueryMethods must be used within a SearchResultProvider"
    );
  return e;
}, Ye = () => {
  const e = P(b);
  if (!e)
    throw new Error(
      "useGlobalSearchSettings must be used within a SearchProvider"
    );
  return e.globalSearchSettings;
}, ae = () => {
  const e = P(b);
  if (!e)
    throw new Error("useSearchData must be used within a SearchProvider");
  return e.searchData;
}, Oe = () => {
  const { loadPage: e } = K(), { result: t } = F(), r = A();
  return async (n) => {
    const s = await e(n, t);
    r({ type: "LOAD_PAGE", payload: { items: s, page: n } });
  };
}, oe = () => {
  const { result: e } = F();
  return e == null ? void 0 : e.meta;
}, Me = () => {
  const { urlSearchParams: e, pathname: t } = ae(), r = oe(), n = r ? r.currentPage + 1 : 0, s = new URLSearchParams(e);
  return s.set("page", n.toString()), `${t}?${s.toString()}`;
}, qe = () => {
  const e = H(!1), t = oe(), r = Me(), n = Oe(), [s, o] = he(!1);
  if (!t)
    return {
      loadMore: () => {
      },
      canLoadMore: !1,
      paginationStats: { totalItems: 0, seen: 0 },
      isLoading: !1,
      pageIncrementHref: r
    };
  const { currentPage: a, totalPages: u, itemsPerPage: c, totalItems: d } = t;
  a === 0 && !e.current && (e.current = !0);
  const l = a + (e.current ? 1 : 0) < u, i = () => {
    if (l)
      return o(!0), n(a + 1).finally(() => o(!1));
    console.warn(
      `Tried to load more products than available, currentPage: ${a}, totalPages: ${u}`
    );
  }, g = (a + (e.current ? 1 : 0)) * c > d ? d : (a + (e.current ? 1 : 0)) * c;
  return {
    loadMore: i,
    canLoadMore: l,
    paginationStats: { totalItems: d, seen: g },
    isLoading: s,
    pageIncrementHref: r
  };
}, et = () => {
  const e = F(), t = A(), { setSortOrder: r } = K(), n = w(() => {
    var o;
    return ((o = e.result) == null ? void 0 : o.sort) || [];
  }, [e.result]), s = C(
    async (o) => {
      const a = n.map((c) => c.id === o ? {
        ...c,
        selected: !c.selected
      } : {
        ...c,
        selected: !1
        // Only one sort can be selected at a time
      });
      if (!a)
        return;
      const u = await r(a, e.result);
      t({ type: "SET_RESULT", payload: u });
    },
    [n, r, t]
  );
  return { sortAlternatives: n, toggleSort: s };
}, _e = (e, t) => {
  const r = [], n = /* @__PURE__ */ new Set();
  for (const o of t) {
    const a = e.filter(
      (u) => o.facetIds.includes(u.id) && (u.type === "checkbox" || u.type === "checkbox-hierarchical")
    );
    if (a.length > 0) {
      const u = a.reduce(
        (d, l) => d + l.selectedCount,
        0
      ), c = {
        id: o.id,
        name: o.name,
        type: "group",
        children: a,
        selectedCount: u,
        relationship: o.relationship || "or",
        compositeField: o.compositeField
      };
      r.push(c), a.forEach((d) => n.add(d.id));
    }
  }
  const s = e.filter(
    (o) => !n.has(o.id)
  );
  return r.push(...s), r;
}, ie = (e) => {
  if (e.type === "group")
    return {
      ...e,
      children: e.children.map(ie)
    };
  if (e.type === "checkbox")
    return {
      ...e,
      values: e.values.filter((t) => t.name !== "undefined")
    };
  if (e.type === "checkbox-hierarchical") {
    const t = (r) => r.filter((n) => n.name !== "undefined").map((n) => ({
      ...n,
      children: n.children ? t(n.children) : void 0
    }));
    return {
      ...e,
      values: t(e.values)
    };
  }
  return e;
}, ue = (e) => e.type === "group" ? e.children.some(ue) : e.type === "checkbox" || e.type === "checkbox-hierarchical" ? e.values.length > 0 : !0;
function V(e, t) {
  return t === "auto" ? e : [...e].sort((r, n) => t === "name" ? r.name.localeCompare(n.name, void 0, { numeric: !0 }) : t === "count" ? n.count - r.count : 0);
}
function T(e, t) {
  return V(e, t).map(
    (r) => r.children ? { ...r, children: T(r.children, t) } : r
  );
}
function je(e, t) {
  return t === "auto" ? e : e.type === "group" ? {
    ...e,
    children: e.children.map((r) => r.type === "checkbox-hierarchical" ? {
      ...r,
      values: T(r.values, t)
    } : { ...r, values: V(r.values, t) })
  } : e.type === "checkbox-hierarchical" ? {
    ...e,
    values: T(e.values, t)
  } : { ...e, values: V(e.values, t) };
}
const tt = () => {
  const e = ve(), t = Pe(), r = xe(), n = F(), s = A(), { setFacets: o, reset: a } = K(), u = w(() => {
    var g;
    if (!((g = n.result) != null && g.facets))
      return [];
    let i = n.result.facets.sort((h, y) => e.facets === "count" ? 0 : e.facets === "name" ? h.name.localeCompare(y.name) : 0).filter((h) => h.id && !t.includes(h.id));
    if (r) {
      const h = r();
      i = _e(i, h);
    }
    return i = i.map(ie), i = i.filter(ue), i = i.map(
      (h) => je(h, e.values ?? "auto")
    ), i;
  }, [
    n.result,
    e.facets,
    e.values,
    t,
    r
  ]), c = w(() => {
    const i = [], g = (h) => {
      h.type === "checkbox-hierarchical" ? Qe(
        h.values
      ).forEach((S) => {
        i.push({
          name: S.name,
          id: S.id,
          facetId: h.id
        });
      }) : h.type === "checkbox" ? h.values.forEach((y) => {
        y.selected && i.push({
          name: y.name,
          id: y.id,
          facetId: h.id
        });
      }) : h.type === "group" && h.children.forEach(g);
    };
    return u.forEach(g), i;
  }, [u]), d = C(
    async (i, g) => {
      const h = u.map((S) => {
        if (S.type === "group") {
          const f = S.children.map((p) => {
            if (p.id === i) {
              if (p.type === "checkbox-hierarchical")
                return Q(p, g);
              if (p.type === "checkbox")
                return k(p, g);
            }
            return p;
          });
          return {
            ...S,
            children: f,
            selectedCount: f.reduce(
              (p, m) => p + m.selectedCount,
              0
            )
          };
        } else if (S.id === i) {
          if (S.type === "checkbox-hierarchical")
            return Q(S, g);
          if (S.type === "checkbox")
            return k(S, g);
        }
        return S;
      }), y = await o(
        h,
        n.result
      );
      s({ type: "SET_RESULT", payload: y });
    },
    [u, o, s, n.result]
  );
  return { facets: u, toggleFacet: d, resetFacets: async () => {
    const i = await a();
    s({ type: "SET_RESULT", payload: i });
  }, activeFacetValues: c };
}, rt = ({
  zeroIndexed: e = !1
} = {}) => {
  const { urlSearchParams: t } = ae(), r = t.get("page"), n = r ? parseInt(r) : 1;
  return (isNaN(n) || n < 1 ? 1 : n) - (e ? 1 : 0);
}, nt = {
  items: [],
  meta: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    itemsPerPage: 0
  },
  facets: [],
  sort: []
}, st = (e) => e.relationship !== "and" ? [] : e.children.map((t) => ({
  facetId: t.id,
  valueIds: t.values.filter((r) => r.selected).map((r) => r.id)
})).filter((t) => t.valueIds.length > 0);
export {
  ze as AutoCompleteProvider,
  Ke as CachedSearchResultsProvider,
  Re as SearchProvider,
  te as SearchResultProvider,
  Z as SearchResultReactQueryProvider,
  Ee as StructuredDataSearchProducts,
  Ze as autoCompleteClientMethods,
  Be as clearSearchResultCache,
  Xe as clearSearchUrlParameters,
  I as collectSelectedCheckboxHierarchicalValues,
  ce as collectSelectedHierarchicalIds,
  Qe as collectTopMostSelectedCheckboxHierarchicalValues,
  Te as createEnhancedQueryMethods,
  L as createFilterKeyFragment,
  Ve as createLoadPageMethod,
  nt as emptySearchResult,
  W as excludedFacetsContext,
  D as extractFilterState,
  U as extractSelectedFacetIds,
  se as extractSelectedSortIds,
  z as facetGroupingContext,
  G as facetSortingContext,
  ie as filterUndefinedValues,
  E as generateSearchQueryKey,
  st as getAndGroupActiveSelections,
  _e as groupFacets,
  ue as hasValues,
  Ae as migrateInfiniteQueryData,
  De as parseUrlFacets,
  Le as parseUrlSort,
  Ie as restoreSelectionsFromUrl,
  b as searchContext,
  ee as searchResultQueryMethodsContext,
  be as searchResultReducer,
  Y as searchResultReducerDispatch,
  X as searchResultReducerState,
  k as toggleCheckboxFacet,
  Q as toggleHierarchicalFacet,
  j as updateUrlWithSearchState,
  Ce as useAutoCompleteClient,
  Je as useAutoCompleteSearch,
  Ue as useCachedSearchResults,
  rt as useCurrentPaginationPage,
  Pe as useExcludedFacets,
  xe as useFacetGrouping,
  ve as useFacetSorting,
  tt as useFacets,
  Ye as useGlobalSearchSettings,
  Me as usePageIncrementedHref,
  ae as useSearchData,
  A as useSearchResultDispatch,
  Fe as useSearchResultItems,
  qe as useSearchResultLoadMore,
  Oe as useSearchResultLoadPage,
  oe as useSearchResultMeta,
  K as useSearchResultQueryMethods,
  F as useSearchResultState,
  et as useSort,
  q as useStructuredDataProductsMapper
};
